const SET_MASTER_CLASSES = (state, masterClasses) => {
    state.masterClasses = masterClasses;
};

const SET_ERROR = (state, error) => {
    state.error = error;
};

const SET_EVENTS = (state, {type, events}) => {
    state.events[type] = events.map(event => {
            return {
                id: event.id,
                slug: event.slug,
                label: event.name,
                endDate: event.endAt.date,
                certificateDownloadable: event.certificateDownloadable,
                invoiceDownloadable: event.invoiceDownloadable
            }
        });
};

export default {
    SET_EVENTS,
    SET_ERROR
}